import { Box, CardMedia, Grid, Typography } from "@mui/material";
import iconUrl from "@/assets/icons/home/new-way/document-arrow-down.svg";
import imageUrl from "@/assets/images/home/new-way/report-lg.png";
import Label from "./Label";
import { imageReportStyles } from "./styles";

const Reports = () => {
  return (
    <Box
      bgcolor="white"
      borderRadius={3}
      py={{ xs: 2, md: 5, xl: 6.75 }}
      pl={{ xs: 2, md: 5, xl: 7.5 }}
      pr={{ xs: 2, md: 5, xl: 6.75 }}
      sx={{ boxShadow: "0 24px 48px -12px rgba(93,97,104,.1)" }}
    >
      <Grid
        container
        columnSpacing={{ xs: 0, md: 3, lg: 5, xl: 19 }}
        sx={{
          minHeight: { md: 335, lg: 378, xl: 402 },
        }}
      >
        <Grid item xs={12} md={6}>
          <Label label="Report" iconUrl={iconUrl} />
          <Typography
            variant="h3"
            fontSize={{ xs: "1.25rem", md: "2rem", lg: "2.5rem" }}
            mb={2}
          >
            Customizable Reports
          </Typography>
          <Typography
            color="text.secondary"
            variant="body1"
            mb={{ xs: 10, md: 0 }}
          >
            Configure reports based on the data that matters most to you. Generate and send at set times to stay on top of asset status, location, and performance.
          </Typography>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box display="flex" alignItems="center" height="100%">
            <CardMedia
              component="img"
              loading="lazy"
              image={imageUrl}
              alt="image"
              sx={imageReportStyles}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Reports;
